import { webFontFamily, webFontFamilyMono } from '@buyerflo/core/tamagui/fonts'
import {
    BRAND_TEAL,
    buildPrimaryThemes,
    darkInputTheme,
    darkPrimaryButtonTheme,
    darkTextAreaTheme,
    darkTheme,
    lightInputTheme,
    lightPrimaryButtonTheme,
    lightTextAreaTheme,
    lightTheme,
} from '@buyerflo/core/tamagui/theme'
import { defaultConfig } from '@tamagui/config/v5'
import { animationsCSS } from '@tamagui/config/v5-css'
import { createTamagui } from 'tamagui'

const config = createTamagui({
    ...defaultConfig,
    animations: animationsCSS,
    settings: {
        ...defaultConfig.settings,
        allowedStyleValues: 'somewhat-strict-web',
        styleCompat: 'react-native',
    },
    fonts: {
        ...defaultConfig.fonts,
        body: {
            family: webFontFamily,
            size: defaultConfig.fonts.body?.size || {},
            lineHeight: defaultConfig.fonts.body?.lineHeight || {},
            weight: defaultConfig.fonts.body?.weight || {},
            letterSpacing: defaultConfig.fonts.body?.letterSpacing || {},
        },
        heading: {
            family: webFontFamily,
            size: defaultConfig.fonts.heading?.size || {},
            lineHeight: defaultConfig.fonts.heading?.lineHeight || {},
            weight: defaultConfig.fonts.heading?.weight || {},
            letterSpacing: defaultConfig.fonts.heading?.letterSpacing || {},
        },
        // Geist Mono — for numeric/tabular cells, timestamps, codes (fontFamily="$mono")
        mono: {
            family: webFontFamilyMono,
            size: defaultConfig.fonts.body?.size || {},
            lineHeight: defaultConfig.fonts.body?.lineHeight || {},
            weight: defaultConfig.fonts.body?.weight || {},
            letterSpacing: defaultConfig.fonts.body?.letterSpacing || {},
        },
    },
    themes: {
        ...defaultConfig.themes,
        // Alias green sub-themes as primary, shifted to brand teal
        ...buildPrimaryThemes(defaultConfig.themes as Record<string, any>),
        dark: {
            ...defaultConfig.themes.dark,
            ...darkTheme,
        },
        dark_Input: {
            ...(defaultConfig.themes as any).dark_Input,
            ...darkInputTheme,
        },
        dark_TextArea: {
            ...(defaultConfig.themes as any).dark_TextArea,
            ...darkTextAreaTheme,
        },

        light: {
            ...defaultConfig.themes.light,
            ...lightTheme,
        },
        light_Input: {
            ...(defaultConfig.themes as any).light_Input,
            ...lightInputTheme,
        },
        light_TextArea: {
            ...(defaultConfig.themes as any).light_TextArea,
            ...lightTextAreaTheme,
        },
        light_Switch: {
            ...(defaultConfig.themes as any).light_Switch,
            backgroundActive: 'rgba(15, 150, 144, 0.6)',
        },
        dark_Switch: {
            ...(defaultConfig.themes as any).dark_Switch,
            background: '#444444',
            backgroundActive: BRAND_TEAL,
        },
        light_primary_Button: {
            ...(defaultConfig.themes as any).light_green_Button,
            ...lightPrimaryButtonTheme,
        },
        dark_primary_Button: {
            ...(defaultConfig.themes as any).dark_green_Button,
            ...darkPrimaryButtonTheme,
        },
    },
})

export type AppConfig = typeof config

declare module 'tamagui' {
    interface TamaguiCustomConfig extends AppConfig {}
}

export default config
